<template>
  <div
    v-if="product.hechsher || product.badge || product.pikuach == 1"
    class="absolute left-0 top-[12px] z-20 min-h-[32px] flex items-center justify-center gap-[4px] leading-7 w-fit h-fit py-0.5 px-2 text-complementary-900 text-base font-bold bg-complementary-300 rounded rounded-l-none"
  >
    <span v-if="product.pikuach != 0"> מוצר בפיקוח </span>
    <template v-else-if="product.hechsher">
      <img
        v-if="product.hechsher.logo && product.hechsher.logo != ''"
        :src="
          'https://images.mishnatyosef.org/images/hechshers/' +
          product.hechsher.logo
        "
        alt="item"
        class="w-[48.29px] h-[22px]"
      />
      <span v-else>{{ product.hechsher.name }}</span>
    </template>
    <span v-if="product.badge">{{ product.badge }}</span>
  </div>
</template>

<script>
export default {
  name: "product-badge",
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
};
</script>